import promise from 'promise';

import LoadingConstants from 'app/shared/constants/LoadingConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

import api from 'app/shared/utils/api';

import ClaimMethod from 'app/shared/model/ClaimMethod';
import ClaimPropertyLookupAll from 'app/shared/model/ClaimPropertyLookupAll';
import ClaimPropertyResponse from 'app/shared/model/ClaimPropertyResponse';

const ClaimActions = {
    getExclusivePropertiesForAllUnverified() {
        return dispatch => dispatch(api.claims.getExclusivePropertiesForAllUnverified())
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return promise.resolve(new ClaimPropertyLookupAll(result.response));
            })
            .catch(err => promise.reject(err.message));
    },
    deleteClaimMethod(type, value) {
        return dispatch => dispatch(api.claims.deleteClaimMethod(type, value))
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return { success: true };
            })
            .catch(err => promise.reject(err.message));
    },
    deleteAllUnverifiedClaimMethod() {
        return dispatch => dispatch(api.claims.deleteAllUnverifiedClaimMethods())
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return { success: true };
            })
            .catch(err => promise.reject(err.message));
    },
    getClaimMethods() {
        return dispatch => dispatch(api.claims.getClaimMethods())
            .then((result) => {
                const { error: errorRMWModel, success, response } = result;
                if (!success) {
                    return promise.reject(errorRMWModel);
                }
                dispatch({
                    type: DispatchConstants.CLAIM_UPDATE_CONTACT_METHODS,
                    payload: {
                        phones: response.phones.map(ClaimMethod),
                        emails: response.emails.map(ClaimMethod),
                    },
                });
                return promise.resolve(result);
            }).catch(() => dispatch({
                type: DispatchConstants.CLAIM_SET_CONTACT_METHODS_LOADING_STATE,
                payload: { loadingState: LoadingConstants.ERROR },
            }));
    },
    setClaimMethods({ phones, emails }) {
        const payload = {};
        if (phones) {
            payload.phones = phones;
        }
        if (emails) {
            payload.emails = emails;
        }
        return dispatch => dispatch({
            type: DispatchConstants.CLAIM_UPDATE_CONTACT_METHODS,
            payload,
        });
    },
    addContactMethod(type, value) {
        return dispatch => dispatch(api.claims.addContactMethod(type, value))
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return { success: true };
            })
            .catch(err => promise.reject(err));
    },
    propertyLookup(type, value) {
        return dispatch => dispatch(api.claims.propertyLookup(type, value))
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return promise.resolve(new ClaimPropertyResponse(result.response));
            })
            .catch(err => promise.reject(err.message));
    },
    propertyLookupAll({ includeVerified, includeUnverified }) {
        return dispatch => dispatch(api.claims.propertyLookupAll({ includeVerified, includeUnverified }))
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return promise.resolve(new ClaimPropertyLookupAll(result.response));
            })
            .catch(err => promise.reject(err.message));
    },
    getExclusiveProperties(type, value) {
        return dispatch => dispatch(api.claims.getExclusiveProperties(type, value))
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return promise.resolve(new ClaimPropertyResponse(result.response));
            })
            .catch(err => promise.reject(err.message));
    },
    convertAllProperties() {
        return dispatch => dispatch(api.users.properties.feedToManual.convertAll())
            .then((result) => {
                if (!result.success) {
                    return promise.reject(result.error.message);
                }
                return promise.resolve((result.response));
            })
            .catch(err => promise.reject(err.message));
    },
    setShowPropertyLookupModal(showModal) {
        return dispatch => dispatch({
            type: DispatchConstants.CLAIM_SHOW_PROPERTY_LOOKUP_MODAL,
            payload: { showPropertyLookupModal: showModal },
        });
    },
};

export default ClaimActions;
